define('view/module/review/ReviewModuleEmptyView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Review module empty view
     *
     * @class ReviewModuleEmptyView
     */
    return LayoutView.extend({

        template: '#reviews_module_empty_view',

        serializeData: function () {
            return {
                message: 'review_empty_view_message'
            };
        }

    });

});
